import { Button, Stack, SvgIcon, Typography } from '@mui/material'
import { IconPlus } from '@tabler/icons-react'

export const PlaceholderPhoto = ({ onClick }: { onClick: () => void }) => {
  return (
    <Stack
      component={Button}
      spacing={1}
      variant="outlined"
      useFlexGap
      onClick={onClick}
      sx={{ height: 1 }}
    >
      <SvgIcon fontSize="small">
        <IconPlus />
      </SvgIcon>
      <Typography variant="body2">Add photo</Typography>
    </Stack>
  )
}
